import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';
import { getRoleListV1, getRoleDetail, getRoleMenus, saveRole, adminRoles } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';


class roles extends Component {

    constructor(props) {
        super(props);
        var url = new URL(window.location.href);
        var location = url.searchParams.get("location");
        var auth_data = JSON.parse(localStorage.getItem("user_data"));
        this.state = {
              logged: localStorage.getItem("authentication"),
              auth_data: JSON.parse(localStorage.getItem("user_data")),
              location: location ? location : (auth_data.access_location ? auth_data.access_location : 'Bengaluru'),
              roleList: [],
              menu_list: [],
              role_id:0,
              openAdd:false,
        };
         
        this.getList();

    }


    componentDidMount() {

      var THIS = this;
      $(document).on('click', '.remove_role', function () {
        var delete_id = $(this).data("id");
        THIS.setState({
          delete_id: delete_id
        })
      });

    }


    getRoleDetail = async () => {
      let req = JSON.stringify({
        id: this.state.id
      });
      getRoleDetail(req).then(res => {
        if (res.status === 1) {
          this.setState({
            role: res.detail.role,
            new_read_access: res.detail.new_read_access,
            new_write_access: res.detail.new_write_access,
            new_download_access: res.detail.new_download_access
          })
        }
      })
    }    



    getList = () => {
      const { login_id, role } = this.state.auth_data;
      let ins = JSON.stringify({
        vendor_id: login_id,
        role: role
      });
      getRoleListV1(ins).then((res) => {
        if (res.status == 1) {
          this.setState({
            roleList: res.list
            
          });
        } else {
          this.setState({
            roleList: [],
          });
        }
      });
    }    



    render() {

        const { roleList, menu_list } = this.state;

        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Roles</h4>
                 
                  
                  <div class="float-right"><a href="/admin/roles/add" class="btn btn-primary btn-sm">Add New</a></div>

   
                 
                  <div class="table-responsive pt-3">
                    <table class="table table-bordered table-sm">
                      <thead>
                        <tr>
                          <th>
                            <strong>S.No</strong>
                          </th>
                          
                           <th>
                            <strong>Role</strong>
                          </th>
                                                   
                          <th>
                            <strong>Action</strong>
                          </th>
                          
                        </tr>
                      </thead>
                      <tbody>
                      {roleList.map((item, i) => {     
                      
                       return <tr>
                          <td>
                            {i+1}
                          </td>
                          
                          <td>
                           {item.role}
                          </td>
                                           
                          <td dangerouslySetInnerHTML={{__html: item.action}} />

                        </tr>

                      })

                      }
                     
                      </tbody>
                    </table>
                  </div>

                

                </div>
              </div>
            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default roles;


// WEBPACK FOOTER //
// ./src/components/bewise/adminRoles.jsx